export const PRIVACY_FORMS = {
  custom: 'privacy_custom',
  none: 'privacy_none',
  elopage: 'privacy_elopage',
}
